/**
 * auth Tommy
 * 路由跳转控制中心
 * wx 13916485732
 */
import { loadMicroApp } from 'qiankun';
import microApp from '../registerMicroApp';
import actions from '../utils/actions';
import store from '../store/index';
const cloneDeep = require('clone-deep');
const loadedApp = {};
console.log(microApp);
export function openView(data) {
	const { path, name, query, parentId, id } = data;
	const { menusHistory, currenMenu, parentIds } = store.getState();
	let fullPath = path;
	// 加载的子应用只存在于并未中断的活动  刷新 关闭 等 就会清空 防止子应用销毁的子应用无加载
	// 当前访问路径是要加载的页面则无需操作
	if (window.location.pathname === path && currenMenu) return;
	if (!path) {
		console.info('新窗口丢失路径！');
		return;
	}
	// 切换组织、当路径为'/'时，默认进入首页
	if (path === '/') {
		return (window.location.href = `${process.env.REACT_APP_SSO_URL}/zeus-system/system-permissions/Home`);
	}
	if (!name) {
		console.info('新窗口丢失名字！');
	}
	// 当时桐邦大屏时 跳出
	if (path === '/system-permissions/tbSzdp') {
		return window.open(`${process.env.REACT_APP_SYSTEM_URL}/system-permissions/tbSzdp`);
  }

  if (path === '/registered-audit-manager/aiPlatform') {
    return window.open(`${process.env.REACT_APP_REGISTEREDAUDIT_URL}/registered-audit-manager/aiPlatform`);
	}
	if (query && Object.keys(query).length) {
		for (const [key, value] of Object.entries(query)) {
			fullPath.includes('?') ? (fullPath = `${fullPath}&${key}=${value}`) : (fullPath = `${fullPath}?${key}=${value}`);
		}
	}
	// 先判断是子应用还是主应用，再判断子应用是否已加载
	const _app = microApp.find((item) => path.includes(item.prefixPath));
	if (_app) {
		const childRoutePath = fullPath.replace(_app.prefixPath, '');
		if (!loadedApp[_app.name]) {
			const app = loadMicroApp(_app); // 多了个参数 prefixPath，但是可以忽略
			loadedApp[_app.name] = {
				app,
				childRoute: []
			};
		}
		// 如果子应用已加载，将子应用的路由纪录添加，并通知子应用增加 keep-alive 的 include
		if (!loadedApp[_app.name].childRoute.includes(childRoutePath)) {
			loadedApp[_app.name].childRoute.push(childRoutePath);
		}
		// 面包屑上原有菜单切换或者新增菜单，都需要通知子应用；
		actions.setGlobalState({ loadedApp, type: 'CHNAGE_MENUS' });
	}
	let curShowMenusInfo = { path: fullPath, name: name || '蜂巢', parentId, id };
	if (!menusHistory.find((item) => item.path === fullPath)) {
		let info = cloneDeep(menusHistory);
		if (fullPath === '/zeus-system/system-permissions/Home') {
			curShowMenusInfo = {
				path: fullPath,
				name: '首页',
				parentId: '495638169874579457',
				id: '648227972788568780'
			};
			info.unshift(curShowMenusInfo);
		} else {
			info.push(curShowMenusInfo);
		}
		store.dispatch({ type: 'ADD_MENUSHISTORY', info });
	}
	// 添加当前显示的菜单信息
	store.dispatch({ type: 'CHANGE_CURMENUSINFO', curShowMenusInfo });
	// 刷新不通知菜单
	fullPath !== `${_app.prefixPath}/reloadView` && store.dispatch({ type: 'ADD_CURRENMENU', info: fullPath });
	// 通知菜单栏选中 和 添加面包屑选中
	if (parentId && !parentIds.includes(parentId)) {
		store.dispatch({ type: 'ADD_PARENTID', info: parentIds.concat(parentId) });
	}
	window.history.pushState(null, '', fullPath);
}
export function closeView(path) {
	const { currenMenu } = store.getState();
	// 先判断是子应用还是主应用
	const _app = microApp.find((item) => path.includes(item.prefixPath));
	if (_app) {
		if (loadedApp[_app.name]) {
			// 移除子应用已缓存的应用
			const childRoutePath = path.replace(_app.prefixPath, '');
			const childRouteIndex = loadedApp[_app.name].childRoute.indexOf(childRoutePath);
			loadedApp[_app.name].childRoute.splice(childRouteIndex, 1);
			// 如果子应用已加载，将子应用的路由销毁，并通知子应用减少 keep-alive 的 include
			actions.setGlobalState({
				loadedApp,
				type: 'CHNAGE_MENUS'
			});
			// 再当前微应用的页面是否已全部关闭 销毁此子应用
			// if (loadedApp[_app.name].childRoute.length === 0) {
			// 	loadedApp[_app.name].app.unmount();
			// 	loadedApp[_app.name] = null;
			// }
		}
		store.dispatch({ type: 'DELETE_MENUSHISTORY', info: path });
		const { menusHistory } = store.getState();
		if (menusHistory.length > 0 && currenMenu === path) {
			openView(menusHistory[menusHistory.length - 1]);
		}
	}
}
export function reloadView(data) {
	const { path, parentId } = data;
	// 先判断是子应用还是主应用
	const _app = microApp.find((item) => path.includes(item.prefixPath));
	if (_app) {
		if (loadedApp[_app.name]) {
			// 移除子应用已缓存的应用
			const childRoutePath = path.replace(_app.prefixPath, '');
			const childRouteIndex = loadedApp[_app.name].childRoute.indexOf(childRoutePath);
			loadedApp[_app.name].childRoute.splice(childRouteIndex, 1);
			// 如果子应用已加载，将子应用的路由销毁，并通知子应用减少 keep-alive 的 include
			actions.setGlobalState({
				loadedApp,
				type: 'CHNAGE_MENUS'
			});
			store.dispatch({ type: 'DELETE_MENUSHISTORY', info: path });
			let operatePath = path === `/zeus-system/system-permissions/Home` ? '' : 'reloadView';
			openView({
				path: `${_app.prefixPath}/${operatePath}`,
				name: '正在刷新...',
				parentId
			});
			setTimeout(() => {
				// 只删除tag 不删除keepalive
				store.dispatch({ type: 'DELETE_MENUSHISTORY', info: `${_app.prefixPath}/${operatePath}` });
				openView(data);
			}, 400);
		}
	}
}
